import * as React from "react";
import { createRoot } from 'react-dom/client';

import NotificationProvider from "./notification/NotificationProvider";
import Notification from "./notification/Notification";
import App from "./App";
import AppExpressCheckout from "./AppExpressCheckout";

const entryElement = document.getElementById("basket-app");

if(entryElement) {
	const root = createRoot(entryElement);
	root.render(
		<NotificationProvider>
			{IS_ONE_CLICK_CHECKOUT_EXPERIMENT ? <AppExpressCheckout /> : <App />}
			<Notification />
		</NotificationProvider>
	);
}
